import { createAuthRedirect } from '@disenchantment/auth-client';

function getFallbackOrigin(): string {
  const fromEnv = (import.meta.env.VITE_APP_URL as string | undefined)?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  return 'http://localhost:5173';
}

export const {
  APP_ENTRY_PATH,
  AUTH_CALLBACK_PATH,
  AUTH_ERROR_PATH,
  getAppOrigin,
  getAuthCallbackUrl,
  getAppEntryUrl,
  listSuggestedRedirectUrls,
} = createAuthRedirect({
  appEntryPath: '/app',
  fallbackOrigin: getFallbackOrigin(),
  extraRedirectPaths: ['/channels', '/invite/*'],
});
